import React from 'react';
import Input from './ui/Input';

export default function DynamicForm({ schema, values, onChange }) {
  const fields = schema?.fields || [];

  const setValue = (key, value) => onChange({ ...values, [key]: value });

  return (
    <div className="space-y-4">
      {fields.map((field) => {
        const value = values[field.key] ?? '';

        if (field.type === 'textarea') {
          return (
            <div key={field.key} className="space-y-1">
              <label className="block text-sm font-semibold text-slate-700">
                {field.label}
                {field.required && <span className="text-red-500 ml-1">*</span>}
              </label>
              <textarea
                rows={4}
                value={value}
                onChange={(e) => setValue(field.key, e.target.value)}
                required={field.required}
                className="w-full px-3.5 py-2.5 border border-slate-300 rounded-lg text-sm bg-white
                  focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent resize-y"
              />
            </div>
          );
        }

        if (field.type === 'select') {
          return (
            <div key={field.key} className="space-y-1">
              <label className="block text-sm font-semibold text-slate-700">
                {field.label}
                {field.required && <span className="text-red-500 ml-1">*</span>}
              </label>
              <select
                value={value}
                onChange={(e) => setValue(field.key, e.target.value)}
                required={field.required}
                className="w-full px-3.5 py-2.5 border border-slate-300 rounded-lg text-sm bg-white
                  focus:outline-none focus:ring-2 focus:ring-brand-500"
              >
                <option value="">Selecciona...</option>
                {(field.options || []).map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>
          );
        }

        return (
          <Input
            key={field.key}
            label={field.label}
            type={field.type === 'date' ? 'date' : field.type === 'number' ? 'number' : 'text'}
            value={value}
            onChange={(e) => setValue(field.key, e.target.value)}
            required={field.required}
          />
        );
      })}
    </div>
  );
}